<div>
  <apx-chart
    #chart
    *ngIf="chartOptions"
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"
    [markers]="chartOptions.markers"
    [dataLabels]="chartOptions.dataLabels"
    [stroke]="chartOptions.stroke"
    [title]="chartOptions.title"
    [legend]="chartOptions.legend">
  </apx-chart>
</div>